<template>
  <div class="page px-5">
    <page-layout>
      <h3
        v-if="this.$route.path === '/tenants/new'"
        slot="header"
        class="my-4 text-truncate"
      >
        New Tenant
      </h3>
      <h3
        v-else
        slot="header"
        class="my-4 text-truncate"
      >
        Edit Tenant
      </h3>
      <tenant-detail-form />
    </page-layout>
  </div>
</template>

<script>
import PageLayout from "@/components/shared/PageLayout.vue";
import TenantDetailForm from "@/components/tenants/TenantDetailForm.vue";
export default {
  name: "TenantDetail",
  components: {
    PageLayout,
    TenantDetailForm
  }
};
</script>
